import { render, staticRenderFns } from "./ModalUserSkeleton.vue?vue&type=template&id=724ee24d"
import script from "./ModalUserSkeleton.vue?vue&type=script&lang=js"
export * from "./ModalUserSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports